var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"mb-0"},[_c('b-row',{staticClass:"text-center"},[_c('h3',{staticStyle:{"text-transform":"uppercase"}},[_vm._v("Welcome to SuperScore")])]),_c('b-row',{staticClass:"p-2 pt-3 pb-3"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }